const ADMIN_VIEWS = {
  RETRACTING: "retract-process/step-two",
  REVISION_REQUESTED: "submit-process/review-article",
};

export default ADMIN_VIEWS;
